import { render, staticRenderFns } from "./NewInvoice.vue?vue&type=template&id=54c5715e&"
import script from "./NewInvoice.vue?vue&type=script&lang=ts&"
export * from "./NewInvoice.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports